"use client";

import { Capacitor } from "@capacitor/core";

export type WebPushAvailability = "available" | "native-app" | "unsupported";

const getCapacitor = () => {
  if (typeof window === "undefined") {
    return undefined;
  }

  return window.Capacitor;
};

export const isNativeCapacitorApp = () => {
  if (Capacitor.isNativePlatform()) {
    return true;
  }

  const capacitor = getCapacitor();

  if (!capacitor) {
    return false;
  }

  if (typeof capacitor.isNativePlatform === "function") {
    return capacitor.isNativePlatform();
  }

  if (typeof capacitor.getPlatform === "function") {
    return capacitor.getPlatform() !== "web";
  }

  return false;
};

export const getWebPushAvailability = (): WebPushAvailability => {
  if (typeof window === "undefined") {
    return "unsupported";
  }

  if (isNativeCapacitorApp()) {
    return "native-app";
  }

  if (!("Notification" in window) || !("serviceWorker" in navigator)) {
    return "unsupported";
  }

  return "available";
};
